import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

/**
 * ProtectedRoute component that handles authentication and redirects
 * @param {React.ReactNode} children - The components to render if authenticated
 * @param {string} basePath - The base path for redirects (defaults to "/glam-admin")
 * @returns {React.ReactNode} - Either the children or a redirect to login
 */
const ProtectedRoute = ({ children, basePath = "/glam-admin" }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login with the correct base path
  if (!isAuthenticated()) {
    // Preserve the intended destination for after login
    return <Navigate to={`${basePath}/login`} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 